import type { Component } from '@ydegouvello/ui';
import { SessionsRepository } from 'repositories/sessions.repository';
import { AbstractComponent } from './abstract.component';

export class InitComponent extends AbstractComponent {
  private static _instance: InitComponent | undefined = undefined;

  private constructor(
    name: string,
    parent?: { readonly containerHtmlElementSelector: string; readonly component: Component },
    readonly sessionRepository: SessionsRepository = SessionsRepository.getInstance(),
  ) {
    super(name, parent);
  }

  static getInstance(
    name = 'init',
    parent?: { readonly containerHtmlElementSelector: string; readonly component: Component },
    sessionRepository: SessionsRepository = SessionsRepository.getInstance(),
  ): InitComponent {
    this._instance ??= new this(name, parent, sessionRepository);
    return this._instance;
  }

  protected override async render(): Promise<void> {
    this.getById('init-error').style.display = 'none';
    this.getById('init-form').addEventListener(
      'submit',
      (event) =>
        void (async () => {
          event.preventDefault();

          await this.safeCall(async () => {
            await this.setLoading(true);

            try {
              const login = this.getById<HTMLInputElement>('init-email').value;
              await this.sessionRepository.init(login);
              await this.navigation.refresh();
            } catch (error) {
              console.error('Failed to initialize session', error);
              await this.setError("Une erreur est survenue lors de l'initialisation de la session.");
            } finally {
              await this.setLoading(false);
            }
          });
        })(),
    );
  }
}
